export enum EventStatus {
  PendingUpdate = 'pending-update',
  Active = 'active',
  Deleted = 'deleted',
  Finished = 'finished',
  Canceled = 'canceled',
  Confirmed = 'confirmed',
}
